import { render, staticRenderFns } from "./StatisticTabsView.vue?vue&type=template&id=73ed5120&"
import script from "./StatisticTabsView.vue?vue&type=script&lang=ts&"
export * from "./StatisticTabsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports